import React, { useState, useEffect } from "react";
import { Col, Row, DropdownToggle, DropdownMenu, DropdownItem, Dropdown, Label } from "reactstrap";
import { getMonthsPositionReport, getAccountStatement } from "../../../services/api/accounts";
import { useSelector } from "react-redux";
import style from "./MonthlyStateComponent.scss";
import { getCurrentAccount, getTexts } from "../../../reducers/selectors";
import pdfSvg from "../../../../public/svg/pdf.svg";
import { Warning } from "../../Warning/Warning";
import { showToast } from "../../../utils/helper";
import GenericButton from "../../UI/Button/Button";
import { Safearea } from "../../UI/Safearea/Safearea";

export const MonthlyStateComponent = ({ title }) => {
  const date = new Date();
  const [pdf, getPdf] = useState();
  const year = date.getFullYear();
  const [userDropdownIsOpen, setUserDropdownIsOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("Cargando...");

  const [loading, setLoading] = useState(false);
  const [months, setMonths] = useState([]);
  const currentAccount = useSelector(getCurrentAccount);
  const texts = useSelector(getTexts);

  const MONTHS_NUMBERS = {
    ENERO: 0,
    FEBRERO: 1,
    MARZO: 2,
    ABRIL: 3,
    MAYO: 4,
    JUNIO: 5,
    JULIO: 6,
    AGOSTO: 7,
    SETIEMBRE: 8,
    SEPTIEMBRE: 8,
    OCTUBRE: 9,
    NOVIEMBRE: 10,
    DICIEMBRE: 11,
  };

  const toggleUserDropdown = () => {
    setUserDropdownIsOpen((prevState) => !prevState);
  };

  const toggleFilterType = (filterType) => {
    if (currentFilter === filterType) setCurrentFilter();
    else setCurrentFilter(filterType);
  };

  useEffect(() => {
    if (currentAccount.id) {
      setLoading(true);
      getMonthsPositionReport({ AccountId: currentAccount.id })
        .then(({ response }) => {
          if (response.months) {
            // Only shows position reports from account starting date
            const filteredMonths = response.months.filter((monthsItem) => {
              const splitMonthsItem = monthsItem.split(" ");
              const year = +splitMonthsItem[1];
              const month = MONTHS_NUMBERS[splitMonthsItem[0].toUpperCase()];
              const monthsItemDate = new Date(year, month + 1, 0);

              return monthsItemDate > new Date(response.firstpossibledate);
            });

            // Orders position reports by date
            const newMonths = filteredMonths.sort((a, b) => {
              const splitA = a.split(" ");
              const splitB = b.split(" ");
              const aYear = +splitA[1];
              const aMonth = MONTHS_NUMBERS[splitA[0].toUpperCase()];
              const bYear = +splitB[1];
              const bMonth = MONTHS_NUMBERS[splitB[0].toUpperCase()];

              if (new Date(aYear, aMonth) > new Date(bYear, bMonth)) return -1;
              return 1;
            });

            setMonths(newMonths);
            setCurrentFilter(newMonths[0]);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [currentAccount]);

  const bateToBlob = (b64Data) => {
    const byteCharacters = atob(b64Data);
    const contentType = "application/pdf";
    const sliceSize = 512;
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const handleClick = (report) => {
    // Get pdf link
    const MonthYear = report.split(" ");
    const newFilter = MonthYear[0] + " " + MonthYear[1];
    setCurrentFilter(newFilter);
    getAccountStatement(currentAccount.AccountNumber, MonthYear[0], MonthYear[1]).then(({ response }) => {
      if (response.fileData.length > 0) {
        const blobFile = bateToBlob(response.fileData);
        // toggleModal(report, URL.createObjectURL(blobFile));

        var a = document.createElement("A");
        // a.href = `data:application/octet-stream;base64,${blobFile}`;
        a.href = URL.createObjectURL(blobFile);
        a.download = `${MonthYear[0]}-${MonthYear[1]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        showToast("No hay estado de cuenta para el mes indicado", true);
      }
    });
  };

  if (currentAccount.noAccounts)
    return (
      <Row>
        <Col>
          <span>No hay cuentas asociadas</span>
        </Col>
      </Row>
    );

  return (
    <React.Fragment>
      <Row className={style.headerTitle}>
        <Label>{title}</Label>
      </Row>
      <Row style={{ backgroundColor: "#f7f7f7", height: "100%" }}>
        <div className={style.mainStateDiv}>
          <Row>
            <Label className={style.desc}>Mes y año</Label>
            <hr style={{ width: "100%" }} />
          </Row>
          <Row>
            {months.length > 0 ? (
              months.map((month) => <ReportRow reportDate={month} onClick={handleClick}></ReportRow>)
            ) : (
              <th className={style.noResultsText}>Sin Resultados</th>
            )}
          </Row>
        </div>
        {/* <Row className={style.body}>
          <button
            id={style.dropdownButton}
            onClick={() => {
              setUserDropdownIsOpen(!userDropdownIsOpen);
            }}
          >
            <span className={style.textImageWrapper}>
              <p>{currentFilter}</p>
              <img src={pdfSvg} className={style.pdf} />
            </span>
            <Dropdown
              isOpen={userDropdownIsOpen}
              toggle={toggleUserDropdown}
              nav
              inNavbar
              className={style.dropdown}
              tag="ul"
            >
              <DropdownToggle nav caret className={style.dropdownToggle}>
                <DropdownMenu className={style.dropDownMenu}>
                  {months.length > 0 ? (
                    months.map((month) => (
                      <DropdownItem
                        className={style.item}
                        onClick={() => {
                          handleClick(month);
                        }}
                      >
                        {month}
                      </DropdownItem>
                    ))
                  ) : (
                    <th>Sin Resultados</th>
                  )}
                </DropdownMenu>
              </DropdownToggle>
            </Dropdown>
          </button>
        </Row> */}
        {/* <Col className={style.wrapperCol} lg="12">
        <p className={style.titleSubText}>Ver estado de cuenta:</p>
        <Row className={style.body}>
          <button
            id={style.dropdownButton}
            onClick={() => {
              setUserDropdownIsOpen(!userDropdownIsOpen);
            }}
          >
            <span className={style.textImageWrapper}>
              <p>{currentFilter}</p>
              <img src={pdfSvg} className={style.pdf} />
            </span>
            <Dropdown
              isOpen={userDropdownIsOpen}
              toggle={toggleUserDropdown}
              nav
              inNavbar
              className={style.dropdown}
              tag="ul"
            >
              <DropdownToggle nav caret className={style.dropdownToggle}>
                <DropdownMenu className={style.dropDownMenu}>
                  {months.length > 0 ? (
                    months.map((month) => (
                      <DropdownItem
                        className={style.item}
                        onClick={() => {
                          handleClick(month);
                        }}
                      >
                        {month}
                      </DropdownItem>
                    ))
                  ) : (
                    <th>Sin Resultados</th>
                  )}
                </DropdownMenu>
              </DropdownToggle>
            </Dropdown>
          </button>
        </Row>
        <Row className={style.warning}>
          <Warning text={texts.notes.statements_note} />
        </Row>
      </Col> */}
      </Row>
    </React.Fragment>
  );
};

export const ReportRow = ({ reportDate, onClick }) => {
  return (
    <React.Fragment>
      <div className={style.reportRow}>
        <Label className={style.reportLabel}>{reportDate}</Label>
        <GenericButton
          handleClick={() => onClick(reportDate)}
          right
          rounded
          label={"Descargar PDF"}
          padding={"8px 12px"}
          iconSvg={[{ width: "20px", item: " ../../svg/ButtonIcons/download.svg" }]}
        ></GenericButton>
      </div>
      <hr style={{ width: "100%" }} />
    </React.Fragment>
  );
};
